import React, { useState, useEffect, useMemo, useCallback } from "react";
import { DeleteOutlined, EllipsisOutlined } from "@ant-design/icons";
import { Popover, Modal, Button } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import images from "../../../themes/appImage";
import { getCommentListLoad } from "../../../redux/slices/inner.slice";
import { imageURL } from "../../../redux/Api/apikit";
import {
  postLikeFail,
  postLikeLoad,
  removePostload,
} from "../../../redux/slices/community.slice";
import RightArrow from "../../../images/right-arrow.png"
import EmojiSelected from "../../../images/select-emoji.png"
import { removeCommentLoad, toxicLoad } from "../../../redux/slices/common.slice";

const apiPayloadInit = {
  offset: 0,
  limit: 10,
};
let hitReaction = null;

const Content = React.memo(({ emojiData, handleEmojiClick }) => {
  return (
    <div className="flex items-center">
      {emojiData.map((emoji) => (
        <div key={emoji.label} className="mr-2 flex gap-1">
          <img
            src={emoji.src}
            alt={emoji.label}
            className="cursor-pointer"
            onClick={() => handleEmojiClick(emoji.emojiName)}
          />
        </div>
      ))}
    </div>
  );
});

const EncouragementPost = ({
  avatarSrc,
  file,
  postType,
  username,
  time,
  description,
  happyFace,
  partyFace,
  redHeart,
  smileyFace,
  smileyHeart,
  comment,
  id,
}) => {
  const key =process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const { commentListData } = useSelector((state) => state.InnerCircleReducer);
  const commonReducerState = useSelector((state) => state.commonReducer);
  const { isPostLikeSuccess, lastCommentData } = useSelector((state) => state.CommunityReducer);

  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const commentsPerPage = 5;
  const [commentsList, setCommentsList] = useState([]);
  const [apiPayload, setApiPayload] = useState(apiPayloadInit);
  const fileString = file ? `${imageURL}${file}` : null;
  const [emojiData, setEmojiData] = useState([]);
  const [commentText, setCommentText] = useState("")
  const memoEmojidata = useMemo(() => emojiData, [emojiData])

  useEffect(() => {
    if (isPostLikeSuccess) {
      const checkLoadState = commentListData?.length >= apiPayload?.limit
      if (checkLoadState == false) {
        const makeLocalComment = {
          comment: lastCommentData.comment,
          commentByAdmin: true,
          createdAt: moment.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          userDetail: null,
          _id: lastCommentData.commentId
        }
        const makeArray = [...commentsList, makeLocalComment]
        setCommentsList(pre => makeArray)
      }
      setCommentText("")
      dispatch(postLikeFail())
    }
  }, [isPostLikeSuccess]);

  useEffect(() => {
    setEmojiData([
      { src: images.hug, emojiName: "smileyFace" },
      { src: images.EyeBrows, emojiName: "happyFace" },
      { src: images.love, emojiName: "redHeart" },
      { src: images.party, emojiName: "partyFace" },
      { src: images.smileyHeart, emojiName: "smileyHeart" },
    ]);
  }, []);

  console.log(smileyFace, happyFace, redHeart, partyFace, smileyHeart, "LIKE REACTION DATA");

  const handleEmojiClick = useCallback((emojiName) => {
    hitReaction = emojiName
    dispatch(
      postLikeLoad({
        typeOfComment: "reaction",
        comment: emojiName,
        post: id,
      })
    );
  }, [emojiData])

  const handelClick = () => {
    setApiPayload((pre) => apiPayloadInit);
    setCommentsList((pre) => []);
    setIsModalVisible((pre) => true);
    const data = {
      limit: 10,
      offset: 0,
      post: id,
    };
    dispatch(getCommentListLoad(data));
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClose = () => {
    setApiPayload((pre) => apiPayloadInit);
    setCommentsList((pre) => []);

    setIsModalVisible(false);
    setCurrentPage(1);
  };


  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = commentListData.slice(
    indexOfFirstComment,
    indexOfLastComment
  );


  useEffect(() => {
    setCommentsList(pre => [...commentsList, ...commentListData])
  }, [commentListData])

  useEffect(() => {
    if (commonReducerState?.removeCommentSuccessIds.commentId) {
      const clone = [...commentsList].filter(item => item._id !== commonReducerState?.removeCommentSuccessIds.commentId)
      setCommentsList(clone)
    }
  }, [commonReducerState?.removeCommentSuccessIds.commentId])

  const handlerShowMoreCommentsHandler = () => {
    const updateOffset = apiPayload.offset + apiPayload.limit;
    const data = {
      ...apiPayload,
      offset: updateOffset,
      post: id,
    };
    dispatch(getCommentListLoad(data));
    setApiPayload((pre) => ({ ...pre, offset: updateOffset }));
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const postCommentHandler = () => {
    dispatch(toxicLoad({
      apiKey : key,
      comment : commentText,
      typeOfComment: "comment",
      post: id,
    }))
  }

  return (
    <div className="border border-royalPurple bg-white rounded-[20px]">
      <div className="p-4">
        <div className="flex gap-2 mb-2">
          <div>
            <img
              src={avatarSrc}
              alt="avatar"
              className="w-[40px] h-[40px] object-contain rounded-full"
            />
          </div>
          <div className="flex flex-col justify-between">
            <div className="text-sm font-semibold text-dark">{username}</div>
            <div className="text-xs text-gray60 font-normal">
              {moment(time).utc().fromNow()}
            </div>
          </div>
          <div className="flex-grow" />
          <div className="cursor-pointer">
            <Popover
              content={
                <Button
                  type="text"
                  onClick={() => {
                    dispatch(
                      removePostload({
                        post: id,
                      })
                    );
                    setOpen(false);
                  }}
                >
                  Delete
                </Button>
              }
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <EllipsisOutlined />
            </Popover>
          </div>
        </div >
        <div className="text-base font-normal break-words text-dark mb-4">
          {description}
        </div>
      </div >
      <div>
        {postType === "textWithGIF" && fileString && (
          <>
            <img src={fileString} alt="gif" className="w-full" />
          </>
        )}
        {postType === "gifOnly" && fileString && (
          <img src={fileString} alt="gif" className="w-full" />
        )}
        {postType === "imageWithText" && fileString && (
          <>
            <img src={fileString} alt="image" className="w-full" />
          </>
        )}
        {postType === "postOnly" && fileString && (
          <>
            <img src={fileString} alt="image" className="w-full" />
          </>
        )}
        {postType === "videoWithText" && fileString && (
          <video width="600" controls>
            <source src={fileString} type="video/mp4" />
          </video>
        )}
        {postType === "videoOnly" && fileString && (
          <video width="600" controls>
            <source src={fileString} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="flex justify-between items-center p-4">
        <div className="flex justify-center items-center gap-2">
          <div>
            <Popover
              content={<Content emojiData={memoEmojidata} handleEmojiClick={handleEmojiClick} />}
              trigger="click"
              open={visible}
              onOpenChange={handleVisibleChange}
            >
              <div
                className="bg-background flex gap-1 items-center rounded-full px-2 cursor-pointer"
                onClick={() => handleVisibleChange(!visible)}
              >
                {smileyFace == 0 && happyFace == 0 && redHeart == 0 && partyFace == 0 && smileyHeart == 0 && <img src={EmojiSelected} className="w-6 h-8 object-contain" />}
                {smileyFace == undefined && happyFace == undefined && redHeart == undefined && partyFace == undefined && smileyHeart == undefined && <img src={EmojiSelected} className="w-6 h-8 object-contain" />}
                {smileyFace > 0 &&
                  <div className="flex gap-1 items-center">
                    <img src={images.hug} alt="love" className="w-5 h-5" />
                    <div>{smileyFace}</div>
                  </div>
                }
                {happyFace > 0 &&
                  <div className="flex gap-1 items-center">
                    <img src={images.EyeBrows} alt="love" className="w-5 h-5" />
                    <div>{happyFace}</div>
                  </div>
                }
                {redHeart > 0 &&
                  <div className="flex gap-1 items-center">
                    <img src={images.love} alt="love" className="w-5 h-5" /> <div>{redHeart}</div>
                  </div>
                }
                {partyFace > 0 &&
                  <div className="flex gap-1 items-center">
                    <img src={images.party} alt="love" className="w-5 h-5" /><div>{partyFace}</div>
                  </div>
                }
                {smileyHeart > 0 &&
                  <div className="flex gap-1 items-center">
                    <img src={images.smileyHeart} alt="love" className="w-5 h-5" /><div>{smileyHeart}</div>
                  </div>
                }
              </div>
            </Popover>
          </div>
          <div
            className="text-gray60 font-normal cursor-pointer"
            onClick={handelClick}
          >
            {comment} Comments
          </div>
        </div>


      </div>

      {isModalVisible && <Modal
        title="Comments"
        visible={isModalVisible}
        onCancel={handleClose}
        footer={null}
        centered
      >
        <div className="h-80 overflow-scroll">
          {commentsList && commentsList.length > 0 ? (
            commentsList.map((comment) => (
              <div className="mb-4 flex items-center justify-between" >
              <div key={comment?._id} className="mb-4">
                <div className="flex items-center mb-2">
                  <img
                    src={
                      comment?.commentByAdmin
                        ? images.matleFitLogo
                        : comment?.userDetail?.avatar
                          ? `${imageURL}${comment?.userDetail?.avatar}`
                          : images.userProf
                    }
                    alt="avatar"
                    className="w-[40px] h-[40px] object-contain mr-2 rounded-full"
                  />
                  <div className="flex flex-col">
                    <div className="text-sm font-semibold">
                      {comment?.userDetail?.userName}
                    </div>
                    <div className="text-xs text-gray60 font-normal">
                      {moment(comment?.createdAt).utc().fromNow()}
                    </div>
                  </div>
                </div>
                <div className="text-base font-normal text-dark">
                  {comment?.comment}
                </div>
             
              </div>
              <DeleteOutlined
                    onClick={() => dispatch(removeCommentLoad({ postId: id, commentId: comment._id }))}
                    style={{ color: "red", cursor: "pointer" }}
                    width={"100px"}
                  />
              </div>

            ))
          ) : (
            <div className="w-full text-center">No comments</div>
          )}
        </div>
        {commentListData?.length >= apiPayload?.limit && <div className="flex mt-3  mb-3 justify-center">
          <div onClick={handlerShowMoreCommentsHandler} className="cursor-pointer border rounded-md py-0.5 px-2 text-sm text-black">Load more</div>
        </div>}
        <div className="flex items-center gap-2">
          <input
            className="form-control"
            type="text"
            placeholder="Write your comment here..."
            name="title"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
          />
          <div onClick={postCommentHandler} className="border p-2 rounded-md cursor-pointer">
            <img
              src={RightArrow}
              className="w-7 h-7 object-contain"
            />
          </div>
        </div>

      </Modal >}
    </div >
  );
};

export default React.memo(EncouragementPost);

